import { FC } from 'react'
import { useDateTime } from '../../../../shared/useDateTime'
import { useAuth } from '../../../../context/auth-context'
import PerText from '../../../../components/custom_components/Text'
import PerFlexRow from '../../../../components/custom_components/FlexRow'
import PerButtonCircle from '../../../../components/custom_components/ButtonCircle'
import PerSpacer from '../../../../components/custom_components/Spacer'
import './NoteItem.less'
import { useTranslation } from 'react-i18next'
import { NoteInfoInput } from '../../../../types'
import { SmartAvatar } from '../../../avatar/SmartAvatar'

interface Props {
  note: NoteInfoInput
  editable: boolean
  remove?: (id: number) => void
}

export const NoteItem: FC<Props> = ({ remove, note, editable }) => {
  const { user } = useAuth()
  const [t] = useTranslation()
  const { formatDateShort, isToday } = useDateTime(user)

  const author = note.author

  return (
    <PerFlexRow align="top" mb="s" className="per-noteItem">
      <PerFlexRow align="middle" className="per-noteItem--user">
        <SmartAvatar
          employeeId={author.id}
          firstName={author.firstName ? author.firstName : undefined}
          lastName={author.lastName ? author.lastName : undefined}
        />
        <PerSpacer ml="xs" mr="l">
          <PerText fontWeight="bold">{author.firstName}</PerText>
          <PerText appearance="flowing-text" color="secondary">
            {isToday(note.date) ? t('global.today') : formatDateShort(note.date)}
          </PerText>
        </PerSpacer>
      </PerFlexRow>

      <div className="per-noteItem--text" data-e2e-noteslist>
        <PerText appearance="flowing-text">{note.text}</PerText>
      </div>
      {editable && !note.id && (
        <PerButtonCircle
          icon="close_stroke"
          ml="xs"
          size="small"
          color="secondary"
          onClick={() => remove && remove(note.id)}
          data-e2e-deletenote-button
        />
      )}
    </PerFlexRow>
  )
}
